import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import {
  Grid,
  GridDetailRow,
  GridToolbar,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import React from "react";
import Images from "../../../Assets/Images";
import Api from "../../../Services/Api";
import "../../../Styles/AddRisks.scss";
import { toastr } from "react-redux-toastr";
import { Popup } from "@progress/kendo-react-popup";

export default class ImpactTable extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      data: [],
      editID: null,
      openDeleteModelFlagView: false,
      probabilityColumns: [],
      dynamicHeatmapProbabilityRange: [],
      heatmapCount: "",
    };
  }

  componentDidMount() {
    this.init();
  }
  init = async () => {
    await this.getHeatmapConfiguration();
    await this.dynamicCols(this.props.dataItem.impactThresholds);
  };
  getHeatmapConfiguration = async () => {
    try {
      let arr = this.props.dynamicHeatmapProbabilityRange
        ? this.props.dynamicHeatmapProbabilityRange
        : [];
      let rangeArray = [];
      arr = arr?.map((item) => {
        item[item.fullDescription] = item.probabilityRangeValue;
        return item;
      });
      rangeArray = arr.map((column, index) => (
        <Column
          key={index}
          field={column.fullDescription}
          title={column.fullDescription + " From"}
          editor="numeric"
          width="110px"
          format="{0:##,#}"
          editable={index === 0 ? false : true}
        />
      ));
      this.setState({
        dynamicHeatmapProbabilityRange:
          this.props.dynamicHeatmapProbabilityRange,
        probabilityColumns: rangeArray,
        heatmapCount: this.props.heatmapCount,
      });
      console.log("heatmapCount", this.props.heatmapCount);
    } catch (error) {
      console.error(error);
    }
  };
  getImpactTableList = async () => {
    try {
      this.props.getImpactList();
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  getFieldName = (orderId) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.orderId === orderId
    );
    return obj?.fullDescription;
  };
  dynamicCols = (data) => {
    try {
      data.map((res) => {
        res.impactThresholdValue.map((item) => {
          let field = this.getFieldName(item.orderId);
          res[field] = item.thresholdValue;
        });
      });
      this.setState({ data: data, loader: false });
    } catch (error) {
      console.error(error);
    }
  };

  addRecord = () => {
    const { data } = this.state;
    const newRecord = {};
    this.setState({
      data: [newRecord, ...data],
      editID: newRecord.thresholdId,
    });
  };
  discard = () => {
    const data = [...this.state.data];
    data.splice(0, 1);
    this.setState({ data });
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
          ref: (td) => {
            const input = td && td.querySelector("input");
            const activeElement = document.activeElement;

            if (
              !input ||
              !activeElement ||
              input === activeElement ||
              !activeElement.contains(input)
            ) {
              return;
            }

            if (input.type === "checkbox") {
              input.focus();
            } else {
              input.select();
            }
          },
        }
        : {
          onClick: () => {
            this.enterEdit(dataItem, cellField);
          },
        };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement) => {
    const trProps = {
      ...trElement.props,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
        if (
          this.state.currentChangedValue &&
          this.state.currentChangedValue.thresholdId
        ) {
          this.updateRecord(this.state.currentChangedValue);
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: item.thresholdId === dataItem.thresholdId ? field : undefined,
    }));
    this.setState({
      data: dataValue,
      currentChangedValue: dataItem,
      editField: field,
    });
  };
  impactvalidation = (impactThresholdValue) => {
    let errortoaster = false;
    for (var i = 0; i < impactThresholdValue.length - 1; i++) {
      if (
        impactThresholdValue[i].ThresholdValue >=
        impactThresholdValue[i + 1].ThresholdValue
      ) {
        errortoaster = true;
        return errortoaster;
      }
    }
    return errortoaster;
  };
  exitEdit = () => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      data: dataValue,
    });
  };

  isValidation = (dataItem) => {
    let flag = false;
    if (
      dataItem.name &&
      dataItem.name != ""
      // dataItem.lowRangeFromValue &&
      // dataItem.highRangeFromValue &&
      // dataItem.veryHighRangeFromValue
    ) {
      flag = true;
    }
    return flag;
  };

  isValidateThresholdRange = (dataItem) => {
    if (dataItem.veryLowRangeFromValue !== 0) {
      toastr.error("Very low range value should be equal to 0");
      return true;
    } else if (dataItem.veryLowRangeFromValue >= dataItem.lowRangeFromValue) {
      toastr.error(
        "Low range value should be greater than very low range value"
      );
      return true;
    } else if (dataItem.lowRangeFromValue >= dataItem.mediumRangeFromValue) {
      toastr.error("Medium range value should be greater than low range value");
      return true;
    } else if (dataItem.mediumRangeFromValue >= dataItem.highRangeFromValue) {
      toastr.error(
        "High range value should be greater than medium range value"
      );
      return true;
    } else if (dataItem.highRangeFromValue >= dataItem.veryHighRangeFromValue) {
      toastr.error(
        "Very high range value should be greater than high range value"
      );
      return true;
    }
  };

  validateImpactName = (dataItem) => {
    if (!dataItem.name.match(/^[a-zA-Z0-9\s]*$/)) {
      return false;
    }
    return true;
  };
  updateRecord = async (dataItem) => {
    try {
      if (!this.isValidation(dataItem)) {
        toastr.error("Please fill the all fields");
        return;
      }
      if (dataItem.name.includes('.')) {
        toastr.error("Impact Name must not contain '.'");
        return;
      }

      this.setState({ ...this.state, loader: true });
      let name = dataItem.name.trim();
      let thresholdId = dataItem.thresholdId;
      let impactId = dataItem.impactId;
      delete dataItem["name"];
      delete dataItem["thresholdId"];
      delete dataItem["impactId"];
      delete dataItem["inEdit"];
      let arr = [];
      var i = 1;
      for (let [key, value] of Object.entries(dataItem)) {
        if (
          this.state.dynamicHeatmapProbabilityRange.some(
            (item) => item.fullDescription === key
          )
        ) {
          arr.push({
            OrderId: this.getOrderId(key),
            ThresholdValue: value,
          });
          i++;
        }
      }
      if (arr.length < this.state.heatmapCount) {
        this.setState({ ...this.state, loader: false });
        toastr.error("Please fill all the fields");

        return true;
      }
      if (this.impactvalidation(arr)) {
        this.setState({ ...this.state, loader: false });
        toastr.error(
          "Entered value should be between the values entered in lower range and in the higher range"
        );
        return;
      }
      var request = {
        thresholdId: thresholdId,
        Name: name,
        ImpactId: impactId,
        impactThresholdValue: arr,
        isDefault: false,
      };
      let response = await Api.updateImpactThreshold(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          currentChangedValue: {},
        });
        toastr.success(response.message);
        this.getImpactTableList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  getOrderId = (field) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.fullDescription === field
    );
    return obj?.orderId;
  };
  saveNewRecord = async (dataItem) => {
    try {
      if (!this.isValidation(dataItem)) {
        toastr.error("Please fill the all fields");
        return;
      }

      if (dataItem.name.includes('.')) {
        toastr.error("Impact Name must not contain '.'");
        return;
      }

      this.setState({ ...this.state, loader: true });
      let name = dataItem.name.trim();
      delete dataItem["name"];
      delete dataItem["inEdit"];

      let arr = [];
      var i = 1;
      for (let [key, value] of Object.entries(dataItem)) {
        arr.push({
          OrderId: this.getOrderId(key),
          ThresholdValue: value,
        });
        i++;
      }
      let newArr = [{ OrderId: 1, ThresholdValue: 0 }].concat(arr);
      if (newArr.length < this.state.heatmapCount) {
        this.setState({ ...this.state, loader: false });
        dataItem["name"] = name;
        toastr.error("Please fill all the fields");

        return true;
      }
      if (this.impactvalidation(newArr)) {
        this.setState({ ...this.state, loader: false });
        toastr.error(
          "Entered value should be between the values entered in lower range and in the higher range"
        );
        return;
      }

      var request = {
        Name: name,
        ImpactId: this.props.dataItem.impactId,
        impactThresholdValue: newArr,
        isDefault: false,
      };
      let response = await Api.AddImpactThreshold(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.getImpactTableList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      impactId: data.impactId,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };

  actionButtons = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="editBtns">
        {eventData.thresholdId ? (
          <ul className="actionIcon">
            <li>
              <a
                title="Remove"
                onClick={() => this.openDeletePopup(eventData)}
                className="redbtn  icon"
              >
                <img src={Images.TRASH} width="10" alt="edit" />
              </a>
            </li>
          </ul>
        ) : (
          <ul className="actionIcon">
            <li>
              <a
                title="Save Action"
                className="greenbtn icon"
                onClick={() => this.saveNewRecord(eventData)}
              >
                <img src={Images.CHECKGREEN} width="10" alt="save" />
              </a>
            </li>
            <li>
              <a
                title="Discard"
                onClick={() => this.discard(eventData)}
                className="redbtn  icon"
              >
                <img src={Images.CLOSE} width="10" alt="edit" />
              </a>
            </li>
          </ul>
        )}
      </td>
    );
  };

  itemChange = (event) => {
    const changedValue = { ...event.dataItem, [event.field]: event.value };
    const dataValue = this.state.data.map((item) =>
      item.thresholdId === event.dataItem.thresholdId
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      data: dataValue,
    });
  };

  deleteThreshold = async () => {
    try {
      var requestParams = {
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        impactId: this.state.impactId,
      };
      let response = await Api.deleteImpactThreshold(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeDeletePopup();
        this.getImpactTableList();
      } else {
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  render() {
    if (this.props.dataItem.impactId) {
      return (
        <div className="riskReportMitigation">
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}

          <Grid
            data={this.state.data}
            cellRender={this.cellRender}
            rowRender={this.rowRender}
            reorderable
            resizable
            editField="inEdit"
            onItemChange={this.itemChange}
          >
            <GridToolbar>
              <div>
                <button
                  title="Add new"
                  className="addthreshold"
                  onClick={this.addRecord}
                >
                  Add threshold
                </button>
              </div>
            </GridToolbar>

            <Column
              title="Actions"
              cell={this.actionButtons}
              width="65px"
              locked={true}
            />
            <Column
              field="name"
              title="Threshold Name *"
              width="150px"
              locked={true}
            />
            {this.state.probabilityColumns}
          </Grid>

          <Popup
            show={this.state.openDeleteModelFlagView}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this threshold?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.deleteThreshold()}
                  className="deleteBtn"
                  type="button"
                >
                  Delete
                </button>
                <button
                  onClick={this.closeDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else {
      return <div className="riskReportMitigation"></div>;
    }
  }
}
